/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const sorHelpers = require('../sorHelpers/sorHelpers');

const updateCreditCardFormSave = function (e) {
  if (!e.detail || e.detail === 1) {
    const $form = $('#editCreditCard');
    // If adyen is available call validation function
    const adyenState = $('input#adyenStateData').length;
    if (adyenState && window.adyenUpdateCardValidate) {
      window.adyenUpdateCardValidate();
    }

    let formValid = sorHelpers.sorValidation.validateForm($form);
    const today = new Date();
    today.setHours(0, 0, 0);
    const expirationDate = new Date();
    const year = parseInt($form.find("[name$='updatecard_expiration_year']").val(), 10);
    const month = parseInt($form.find("[name$='updatecard_expiration_month']").val(), 10);
    if (year && month) {
      expirationDate.setMonth(month - 1);
      expirationDate.setFullYear(year);
      expirationDate.setHours(0, 0, 0);
      if (expirationDate.getTime() <= today.getTime()) {
        formValid = false;
        sorHelpers.sorModal.initWarningModal(SmartOrderRefillSettings.Resources.SOR_CREDITCARD_ERROR);
      }
    }

    if (formValid) {
      const $loaderHost = sorHelpers.sorLoader.getModalHost($(e.currentTarget));
      sorHelpers.sorLoader.start($loaderHost);
      setTimeout(function () {
        $.ajax({
          type: 'POST',
          url: $form.attr('action'),
          data: $form.serialize(),
          success: function (response) {
            if (response.success) {
              sorHelpers.sorModal.closeModal();
              window.location.href = SmartOrderRefillSettings.Urls.manageOrders;
            } else if (response.message) {
              sorHelpers.sorLoader.stop($loaderHost);
              sorHelpers.sorModal.initWarningModal(response.message);
            } else {
              sorHelpers.sorLoader.stop($loaderHost);
              sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_CREDITCARD_ERROR);
            }
          },
          error: function (err) {
            if (err.responseJSON && err.responseJSON.redirectURL) {
              window.location.href = err.responseJSON.redirectURL;
            } else {
              sorHelpers.sorLoader.stop($loaderHost);
              sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR);
            }
          }
        });
      }, 1000);
    }
  }
};

const updateCreditCardFormOptions = {
  autoOpen: true,
  bgiframe: true,
  title: typeof SmartOrderRefillSettings !== 'undefined' ? SmartOrderRefillSettings.Resources.SOR_UPDATE_CREDIT_CARD_TITLE : '',
  modal: true,
  emptyOnClose: false,
  width: '37.5rem',
  buttons: {
    SOR_GLOBAL_CLOSE: sorHelpers.sorModal.closeModal,
    SOR_GLOBAL_SAVE: updateCreditCardFormSave
  }
};

const initCreditCardView = function () {
  $(document)
    .off('click', '.update-card')
    .on('click', '.update-card', function (e) {
      if (!e.detail || e.detail === 1) {
        const $parentHost = sorHelpers.sorLoader.getModalHost($(this));
        if ($parentHost.hasClass('sor-loader-host')) {
          return;
        }
        sorHelpers.sorLoader.start($parentHost);
        const url = $(this).attr('data-link');
        const $container = sorHelpers.sorModal.createContainer('#updatecreditcard');

        $container.load(url, function (response, status) {
          if (status === 'error') {
            sorHelpers.sorLoader.stop($parentHost);
            return;
          }
          sorHelpers.sorModal.createModal($container, updateCreditCardFormOptions);
          sorHelpers.sorModal.onShown($container, function () {
            sorHelpers.sorLoader.stop($parentHost);
          });
          $("select[id$='_updatecard_expiration_month']").val(
            parseInt($('#updatecreditcard').find('.expiration-date-wrapper').attr('data-expmonth'), 10)
          );
          $("select[id$='_updatecard_expiration_year']").val($('#updatecreditcard').find('.expiration-date-wrapper').attr('data-expyear'));
        });
      }
    });
};

const initCreditCardExpirationWarning = function () {
  /**
   * @description determin if card expiration worning should be shown
   * @param {string} month month form element value
   * @param {string} year year form element value
   */
  function toggleExpirationWarning(month, year) {
    if (typeof month !== 'undefined' && typeof year !== 'undefined' && month && year) {
      const expirationDate = new Date(new Date(year, month).setDate(0));
      const currentDate = new Date();
      const nextYear = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate() - 1);

      if (expirationDate - nextYear <= 0 && expirationDate > currentDate) {
        $('.credit_card_expiration_warning').show();
      } else {
        $('.credit_card_expiration_warning').hide();
      }
    }
    if (month === '' && year === '') {
      $('.credit_card_expiration_warning').hide();
    }
  }

  $(document).on(
    'change',
    '.pt_checkout [name$="creditCard_expiration_month"], .pt_checkout [name$="creditCard_expiration_year"]',
    function () {
      const month = $('.pt_checkout [name$="creditCard_expiration_month"]').val();
      const year = $('.pt_checkout [name$="creditCard_expiration_year"]').val();
      toggleExpirationWarning(month, year);
    }
  );
  $(document).on(
    'change',
    '#checkout-main [name$="creditCardFields_expirationMonth"], #checkout-main [name$="creditCardFields_expirationYear"]',
    function () {
      const month = $('#checkout-main [name$="creditCardFields_expirationMonth"]').val();
      const year = $('#checkout-main [name$="creditCardFields_expirationYear"').val();
      toggleExpirationWarning(month, year);
    }
  );
  $('.saved-payment-instrument').on('click', function () {
    const expirationDate = $(this).filter('.saved-credit-card-expiration-date').prevObject[0].innerText;
    const content = expirationDate.split('Ending ');
    const date = content[1].split('/');
    const month = parseInt(date[0], 10);
    const year = parseInt(date[1], 10);
    toggleExpirationWarning(month, year);
  });
  $('.add-payment').on('click', function () {
    const month = $('#checkout-main [name$="creditCardFields_expirationMonth"]').val();
    const year = $('#checkout-main [name$="creditCardFields_expirationYear"').val();
    toggleExpirationWarning(month, year);
  });
  $('.cancel-new-payment').on('click', function () {
    const month = $('#checkout-main [name$="creditCardFields_expirationMonth"]').val();
    const year = $('#checkout-main [name$="creditCardFields_expirationYear"').val();
    toggleExpirationWarning(month, year);
  });
};

module.exports = {
  initCreditCardView: initCreditCardView,
  initCreditCardExpirationWarning: initCreditCardExpirationWarning
};
